import { useAppSelector, useAppDispatch } from 'app/hooks';
import {
  JobTypeEnum,
  JobUIStatusEnum,
  RoleJobStatusCollectionMap,
  SUPPLIER_JOB_STATUS_NOT_IN_NETWORK_COLLECTION,
} from 'domains/workspaceDomain';
import { useUser, useRole } from 'hooks';

export const useJobStatusCollection = (filter?: JobUIStatusEnum) => {
  const user = useUser();
  const { supplierRole } = useRole();
  const networks = useAppSelector((state) => state.app.orgNetworks);
  const isMember = useAppSelector((state) => state.network.isMember);
  if (!networks) {
    return [filter || JobUIStatusEnum.SAVE_QUOTES];
  }
  if (supplierRole) {
    if (!isMember) {
      return SUPPLIER_JOB_STATUS_NOT_IN_NETWORK_COLLECTION;
    }
    return RoleJobStatusCollectionMap[JobTypeEnum.NETWORK];
  }

  return RoleJobStatusCollectionMap[user!.siteRole];
};

export const useGetJobCountHandler = () => {
  const {
    workspace: { getJobCountByStatusFilter },
  } = useAppDispatch();
  const f = useJobStatusCollection();
  return () => getJobCountByStatusFilter(f);
};
